export default "__VITE_ASSET__FYsHV8NY__"